const isDev = process.env.NODE_ENV === 'development';
const enableDebug = process.env.REACT_APP_ENABLE_LOG_DEBUG === 'true';

export const logger = {
  log: (...args) => {
    if (isDev && enableDebug) {
      // eslint-disable-next-line no-console
      console.log('[LOG]', ...args);
    }
  },
  warn: (...args) => {
    if (isDev && enableDebug) {
      // eslint-disable-next-line no-console
      console.warn('[WARN]', ...args);
    }
  },
  error: (...args) => {
    // Always surface errors in dev; in prod rely on monitoring service (placeholder)
    if (isDev) {
      // eslint-disable-next-line no-console
      console.error('[ERROR]', ...args);
    }
  }
};

export default logger;
